import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class BringozLineChartComponent implements IController {
  data: any;
  from: any;
  to: any;
  colors: any;

  lineChart: any;
  totals: any;
  showLegend: any;
  defaultColors: any;

  constructor(private chartColors, private moment) {
  }

  $onInit() {
    this.defaultColors = this.chartColors;
    this.lineChart = {
      type: 'LineChart',
      data: this.data,
      sliceVisibilityThreshold: 0,
      options: {
        chartArea: {
          width: '94%'
        },
        hAxis: {
          format: 'dd/MM/yy',
          minValue: this.moment(this.to).endOf('day').toDate(),
          maxValue: this.moment(this.from).startOf('day').toDate(),
          gridlines: {
            color: 'transparent',
          }
        },
        vAxis: {
          gridlines: {
            color: '#c5c5c5'
          }
        },
        targetAxisIndex: this.showLegend ? 1 : undefined,
        legend: this.showLegend ?
          {
            fontSize: 14,
            color: '#757575'
          }
          : 'none',
        colors: this.colors || this.defaultColors,
      },
    };
  }

  $onChanges(changes) {
    if (changes.data && !changes.data.isFirstChange()) {
      this.lineChart.data = this.data;
      if (this.from && this.to) {
        this.lineChart.options.hAxis.minValue = this.moment(this.from).startOf('day').toDate();
        this.lineChart.options.hAxis.maxValue = this.moment(this.to).endOf('day').toDate();
      }
    }
  }

  readyHandler() {
    let container = document.getElementById('line_chart_div');
    if (this.totals) {
      this.setLegendTotals(this.totals, container);
    }
  }

  private setCount(dataTable) {
    if (dataTable) {
      let rowsCount = dataTable.getNumberOfRows();
      return rowsCount <= 40 ? 15 : undefined;
    } else {
      return undefined;
    }
  }

  private setLegendTotals(totals, container) {
    let elements = container.getElementsByTagName('text');

    _.forEach(elements, (label) => {
      if (label.getAttribute('fill') === '#757575') {
        let labelName = label.innerHTML;
        if (totals[labelName]) {
          label.textContent = ' ' + totals[labelName] + ' ' + labelName;
        }
      }
    });
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozLineChart', {
    bindings: {
      data: '<',
      from: '<',
      to: '<',
      colors: '<'
    },
    templateUrl: 'app/modules/commons/components/bringoz-line-chart/bringoz-line-chart.html',
    controller: BringozLineChartComponent
  });
